import { ThemeProvider } from '@material-ui/styles';
/**
 * @ignore - do not document.
 */

export default ThemeProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/styles/MuiThemeProvider.js
// module id = 303
// module chunks = 0